import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IReinviteUserPayload } from '@app-store/slices/users/reinvite'

interface TaskAction extends Action {
    payload: IReinviteUserPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.users.reinvite
function* reinviteUserSagaTask({ payload }) {
    try {
        const response = yield axios.put(`/users/reinvite${payload.id}`, { ...payload.data })
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            yield put(onFailure(''))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* reinviteUserSaga(): any {
    yield takeLatest<TaskAction>(onRequest, reinviteUserSagaTask)
}

export default reinviteUserSaga
